module.exports = __webpack_public_path__ + "static/media/gnocsis-main.89a4b640.png";